import { QUERY_KEYS } from 'api/query-keys';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { sharedPaymentService } from 'api/services';
import { Site } from 'shared/hooks';

type ResendPaymentMutationContext = { site: Site; paymentId: string };
type ResendPaymentMutationOptions = UseMutationOptions<
  unknown,
  Error,
  ResendPaymentMutationContext
>;
export const useResendPayment = (options?: ResendPaymentMutationOptions) => {
  const mutationFn = async ({ site, paymentId }: ResendPaymentMutationContext) =>
    await sharedPaymentService.resendPayment(site, paymentId);
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options ?? {};

  return useMutation(mutationFn, {
    onSuccess: async (data, variables, context) => {
      queryClient.invalidateQueries(QUERY_KEYS.payments());
      onSuccess && onSuccess(data, variables, context);
    },
    ...restOptions,
  });
};
